module.exports = __webpack_public_path__ + "static/media/AU Research.8eafac2d.png";